import React from "react";
import {
  Modal, ModalHeader, ModalBody
} from "reactstrap";
import ToggleCheckbox from "./ToggleCheckbox";

function ClientActionModal({ open, toggle, clientDetails, isArchive, onToggle, isLoading }) {
  return (
    <Modal isOpen={open} toggle={toggle} centered={true}>
      <ModalHeader toggle={toggle}>
        {isArchive ? (clientDetails?.isArchive ? "De-archive Client" : "Archive Client") : "Portal Access"}
      </ModalHeader>
      <ModalBody>
        <h3>{isArchive ? (clientDetails?.isArchive ? "Client is archived" : "Client is not archived") : (clientDetails?.isActive ? "Client is active" : "Client is not active")}</h3>
        <ToggleCheckbox
          checked={isArchive ? clientDetails?.isArchive : clientDetails?.isActive}
          onChange={onToggle}
          isLoading={isLoading}
          id={clientDetails?._id}
        />
      </ModalBody>
    </Modal>
  );
}

export default ClientActionModal;